package app.svg

import dev.fritz2.core.RenderContext

fun RenderContext.chevronUp(className: String) {
    svg(className) {
        attr("xmlns", "http://www.w3.org/2000/svg")
        attr("viewBox", "0 0 24 24")
        attr("fill", "currentColor")
        path {
            attr("fill-rule", "evenodd")
            attr("clip-rule", "evenodd")
            attr("d", "M11.47 7.72a.75.75 0 0 1 1.06 0l7.5 7.5a.75.75 0 1 1-1.06 1.06L12 9.31l-6.97 6.97a.75.75 0 0 1-1.06-1.06l7.5-7.5Z")
        }
    }
}
